import React, { useEffect, useState } from 'react';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
import { upload } from '../../store/actions/vendor/Vendor';
import { Table, Button } from 'reactstrap';
import { connect } from 'react-redux';
import {
  getCategoryDetails,
  getCategory as getCategoryList,
  updateCategory
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';
import CardBody from '../../components/Card/CardBody.js';
import CardFooter from '../../components/Card/CardFooter.js';
import GridItem from '../../components/Grid/GridItem.js';
import GridContainer from '../../components/Grid/GridContainer.js';
import CustomInput from '../../components/CustomInput/CustomInput.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const CategoryEdit = (props) => {
  const classes = useStyles();
  const [imageUploadMessage, updateImageUploadMessage] = useState('');
  const [categoryDetail, updatecategoryDetail] = useState(
    props.categoryDetails
  );

  useEffect(() => {
    var categoryId = props.match.params.categoryId;
    props.getCategoryDetails(categoryId);
    props.getCategoryList();
  }, []);

  useEffect(() => {
    if (props.categoryDetails) {
      const tempCategoryDetail = {
        superCategoryId: props.categoryDetails.superCategoryId,
        categoryId: props.categoryDetails.id,
        name: props.categoryDetails.name,
        icon: props.categoryDetails.icon
      };
      updatecategoryDetail(tempCategoryDetail);
    }
  }, [props?.categoryDetails]);

  const onUpload = (event) => {
    updateImageUploadMessage('Uploading the file, please wait...');

    let data = new FormData();
    data.append('files', event.target.files[0]);

    // Upload image
    props
      .upload(data)
      .then((response) => {
        if (response.status === 201) {
          updateImageUploadMessage('File uploaded successfully.');
          let categoryDetail = categoryDetail;
          categoryDetail.icon = `${response.data.uploads[0].path}`;
          updateCategory(categoryDetail);
        } else {
          updateImageUploadMessage('Please, try Again');
        }
      })
      .catch((error) => {
        updateImageUploadMessage(
          'An error occurred while executing the query. Please try Again'
        );
      });
  };

  const onChange = (event) => {
    let tempCategoryDetail = { ...categoryDetail };
    tempCategoryDetail[event.target.name] = event.target.value;
    updatecategoryDetail(tempCategoryDetail);
  };

  const onSubmit = (event) => {
    event.preventDefault();
    props.updateCategory(categoryDetail).then((data) => {
      if (data) {
        props.history.push(
          `/admin/all-category/${categoryDetail.superCategoryId}`
        );
      }
    });
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>Update a Category</h4>
        <p className={classes.cardCategoryWhite}>
          When choosing icon, PNG images would be better over JPG or imap
        </p>
      </CardHeader>
      <CardBody>
        <br />
        <GridContainer>
          <GridItem xs={12} sm={12} md={3}>
            <CustomInput
              labelText="Category Name"
              value={categoryDetail?.name}
              onChange={onChange}
              name="name"
              id="name"
              labelProps={{
                shrink: true
              }}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <GridItem xs={12} sm={12} md={4}>
            <CustomInput
              labelText="Category Icon"
              id="icon"
              type="file"
              name="icon"
              accept="image/png, image/jpeg, image/jpg"
              onChange={onUpload}
              formControlProps={{
                fullWidth: true
              }}
            />
          </GridItem>
          <br />
          <p style={{ color: '#000' }}>{imageUploadMessage}</p>
        </GridContainer>
      </CardBody>
      <CardFooter>
        <Button
          type="submit"
          onClick={onSubmit}
          style={{
            color: '#fff',
            backgroundColor: '#9c27b0',
            boxShadow:
              '0 2px 2px 0 rgba(156, 39, 176, 0.14), 0 3px 1px -2px rgba(156, 39, 176, 0.2), 0 1px 5px 0 rgba(156, 39, 176, 0.12)'
          }}
        >
          Update Category
        </Button>
      </CardFooter>
      <br /> <br />
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Name</th>
            <th>Super-Category</th>
            <th>Icon</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <th>1</th>
            <td>{categoryDetail?.name}</td>
            {props.superCategories
              .filter(
                (categorieFilter) =>
                  categorieFilter.id === categoryDetail?.superCategoryId
              )
              .map((type) => (
                <td key={type.id}>{type.name}</td>
              ))}
            <td>
              <img
                src={categoryDetail?.icon}
                style={{ height: '70px' }}
                alt=""
              />
            </td>
          </tr>
        </tbody>
      </Table>
    </>
  );
};

const mapStateWithProps = (state) => ({
  categoryDetails: state.admin.categoryDetails,
  superCategories: state.admin.superCategories
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getCategoryList: () => dispatch(getCategoryList()),
    getCategoryDetails: (categoryId) =>
      dispatch(getCategoryDetails(categoryId)),
    updateCategory: (categoryData) => dispatch(updateCategory(categoryData)),
    upload: (data) => dispatch(upload(data))
  };
};

export default connect(mapStateWithProps, mapDispatchWithProps)(CategoryEdit);
